//frontend/src/pages/history/historystages/AncientCivilisations.jsx
import React from 'react';
import JourneyPage from '../../../components/SubjectsPage';
import historyImage from '../../../assets/history2/Historical_Topics_-_19th_Century.png';

const subTopics = [
  { name: 'Industrial Revolution', route: '/History-Industrial-Revolution', key: 'Industrial Revolution' },
  { name: 'British Empire', route: '/History-British-Empire', key: 'British Empire' },
  { name: 'Meiji Restoration (Japan)', route: '/History-Meiji-Restoration', key: 'Meiji Restoration (Japan)' },
  { name: 'Scramble for Africa', route: '/History-Scramble-for-Africa', key: 'Scramble for Africa' },
  { name: 'Unification of Germany and Italy', route: '/History-Unification-Germany-Italy', key: 'Unification of Germany and Italy' }
];


function HistoryPage19th() {
  return (
    <JourneyPage
      title="The 19th century"
      backgroundImage={historyImage}
      subTopics={subTopics}
      backRoute="/history2"
      chapterFooter=""
    />
  );
}

export default HistoryPage19th;
